import { render, staticRenderFns } from "./AppCardBody.vue?vue&type=template&id=1824b0e5&scoped=true&lang=pug&"
import script from "./AppCardBody.vue?vue&type=script&lang=js&"
export * from "./AppCardBody.vue?vue&type=script&lang=js&"
import style0 from "./AppCardBody.vue?vue&type=style&index=0&id=1824b0e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1824b0e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
